/**
 * Format duration for display
 * @param durationMinutes - Duration in minutes
 * @returns Formatted duration string
 */
export const formatDuration = (durationMinutes: number | null): string => {
  if (durationMinutes === null || durationMinutes === 0) {
    return '0 min';
  }
  
  // Round up to the nearest minute
  const roundedMinutes = Math.ceil(durationMinutes);
  
  if (roundedMinutes < 60) {
    return `${roundedMinutes} min`;
  }
  
  const hours = Math.floor(roundedMinutes / 60);
  const minutes = roundedMinutes % 60;
  
  if (minutes === 0) {
    return `${hours}h`;
  }
  
  return `${hours}h ${minutes}m`;
}; 